export default __webpack_public_path__ + "static/media/track-elements-location-on.3d10c963.svg";